define("shared/components/shared/publish/switcher/index", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "ember-concurrency", "later/utils/constants", "shared/utils/uuid", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _emberConcurrency, _constants, _uuid, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _checkOnboardingAndOpen, _openPublishingSetupPanel;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@embroider/macros",0,"@glimmer/component",0,"ember-concurrency",0,"later/utils/constants",0,"shared/utils/uuid",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.showPublishSwitcher}}
    <div
      class={{concat-classes
        "o--btn cPM--field__dropdown qa--post_type_dropdown at--testImgTour__pubBtnMethod at--createPostTour__pubBtn"
        this.dropdownTargetClass
        (if this.isDisabled "is--disabled")
      }}
      data-test-id="publish-switcher"
    >
      {{#if @socialProfile.hasPublishingMethod}}
        {{this.switcherText}}
        <span>
          {{svg-jar "caret-down" class="o--icon"}}
        </span>
      {{else}}
        {{t "posts.modal.auto_publish.no_publishing_method"}}
      {{/if}}
    </div>
    {{#if (and this.shouldRenderEmberDrop (not this.isDisabled))}}
      {{! the if statement above }}
      <Shared::Ui::EmberDrop
        @constrainToScrollParent={{true}}
        @constrainToWindow={{true}}
        @contentSelector={{concat "." this.contentClass}}
        @openOnInsert={{this.shouldPromptConnectBusiness}}
        @openOnInsertDelay={{500}}
        @position="bottom left"
        @target={{concat "." this.dropdownTargetClass}}
        class="u--inline"
        as |emberDrop|
      >
        <div
          class={{concat-classes
            "o--dropWrapper"
            this.contentClass
            (if this.shouldPromptConnectBusiness "u--fadeIn u--glow")
          }}
        >
          {{#if @post.autoPublish}}
            {{#if this.auth.hasDevices}}
              {{! Switch to Notification Publishing }}
              <Shared::Publish::Switcher::Item::PublishMethod
                @setPublishMethod={{this.setPublishMethod}}
                @text={{t "posts.modal.auto_publish.send_notification"}}
              />
            {{else}}
              {{! Set Up Notification Publishing }}
              <Shared::Publish::Switcher::Item::BusinessButton
                @buttonText={{t "posts.modal.auto_publish.setup_now"}}
                @infoText={{t "posts.modal.notification_publish.download_mobile_app"}}
                @onClick={{fn this.openPublishingSetupPanel emberDrop this.notificationSetupComponent}}
                @title={{this.setupAutoPublishingText}}
              />
            {{/if}}
          {{else if this.tiktokAutoPublishIssue}}
            <Shared::Publish::Switcher::Item::BusinessButton
              @buttonText={{t "shared_words.refresh"}}
              @infoText={{this.autoPublishIssue}}
              @onClick={{fn this.connectBusiness emberDrop}}
            />
          {{else if this.autoPublishIssue}}
            {{! Auto Publish Issue }}
            <Shared::Publish::Switcher::Item::InfoText
              @buttonAction={{this.transitionToUpgrade}}
              @buttonText={{t (if this.showLegacyUpgrade "posts.modal.auto_publish.switch_plan" "shared_words.upgrade")}}
              @infoText={{this.autoPublishIssue}}
              @showButton={{this.showUpgrade}}
            />
          {{else if this.isCreatorStory}}
            <Shared::Publish::Switcher::Item::BusinessButton
              @buttonText={{t "posts.modal.auto_publish.setup_now"}}
              @infoText={{this.enableBusinessProfileText}}
              @onClick={{this.transitionToIgHelp}}
              @title={{t "posts.modal.auto_publish.setup_publishing"}}
            />
          {{else if this.canAutoPublish}}
            {{! Switch to Auto Publish }}
            <Shared::Publish::Switcher::Item::PublishMethod
              @setPublishMethod={{this.setPublishMethod}}
              @text={{t "posts.modal.auto_publish.auto_publish"}}
            />
          {{else}}
            {{! Refresh Credentials }}
            {{#if (or @socialProfile.isProfessional @socialProfile.isTiktok)}}
              <Shared::Publish::Switcher::Item::BusinessButton
                @buttonText={{t
                  (if @socialProfile.isTiktok "shared_words.refresh" "posts.modal.auto_publish.connect_business")
                }}
                @infoText={{t "posts.modal.auto_publish.attach_profile"}}
                @onClick={{fn this.connectBusiness emberDrop}}
              />
            {{else}}
              {{! Convert to Business  }}
              <Shared::Publish::Switcher::Item::BusinessButton
                @buttonText={{t "posts.modal.auto_publish.setup_now"}}
                @infoText={{this.enableBusinessProfileText}}
                @onClick={{fn this.openPublishingSetupPanel emberDrop this.autoPublishingSetupComponent}}
                @title={{this.setupAutoPublishingText}}
              />
            {{/if}}
          {{/if}}
        </div>
      </Shared::Ui::EmberDrop>
    {{/if}}
  {{/if}}
  */
  {
    "id": "Tt2YernQ",
    "block": "[[[41,[30,0,[\"showPublishSwitcher\"]],[[[1,\"  \"],[10,0],[15,0,[28,[37,1],[\"o--btn cPM--field__dropdown qa--post_type_dropdown at--testImgTour__pubBtnMethod at--createPostTour__pubBtn\",[30,0,[\"dropdownTargetClass\"]],[52,[30,0,[\"isDisabled\"]],\"is--disabled\"]],null]],[14,\"data-test-id\",\"publish-switcher\"],[12],[1,\"\\n\"],[41,[30,1,[\"hasPublishingMethod\"]],[[[1,\"      \"],[1,[30,0,[\"switcherText\"]]],[1,\"\\n      \"],[10,1],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"caret-down\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[1,[28,[35,3],[\"posts.modal.auto_publish.no_publishing_method\"],null]],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[41,[28,[37,4],[[30,0,[\"shouldRenderEmberDrop\"]],[28,[37,5],[[30,0,[\"isDisabled\"]]],null]],null],[[[1,\"    \"],[8,[39,6],[[24,0,\"u--inline\"]],[[\"@constrainToScrollParent\",\"@constrainToWindow\",\"@contentSelector\",\"@openOnInsert\",\"@openOnInsertDelay\",\"@position\",\"@target\"],[true,true,[28,[37,7],[\".\",[30,0,[\"contentClass\"]]],null],[30,0,[\"shouldPromptConnectBusiness\"]],500,\"bottom left\",[28,[37,7],[\".\",[30,0,[\"dropdownTargetClass\"]]],null]]],[[\"default\"],[[[[1,\"\\n      \"],[10,0],[15,0,[28,[37,1],[\"o--dropWrapper\",[30,0,[\"contentClass\"]],[52,[30,0,[\"shouldPromptConnectBusiness\"]],\"u--fadeIn u--glow\"]],null]],[12],[1,\"\\n\"],[41,[30,3,[\"autoPublish\"]],[[[41,[30,0,[\"auth\",\"hasDevices\"]],[[[1,\"            \"],[8,[39,8],null,[[\"@setPublishMethod\",\"@text\"],[[30,0,[\"setPublishMethod\"]],[28,[37,3],[\"posts.modal.auto_publish.send_notification\"],null]]],null],[1,\"\\n\"]],[]],[[[1,\"            \"],[8,[39,9],null,[[\"@buttonText\",\"@infoText\",\"@onClick\",\"@title\"],[[28,[37,3],[\"posts.modal.auto_publish.setup_now\"],null],[28,[37,3],[\"posts.modal.notification_publish.download_mobile_app\"],null],[28,[37,10],[[30,0,[\"openPublishingSetupPanel\"]],[30,2],[30,0,[\"notificationSetupComponent\"]]],null],[30,0,[\"setupAutoPublishingText\"]]]],null],[1,\"\\n\"]],[]]]],[]],[[[41,[30,0,[\"tiktokAutoPublishIssue\"]],[[[1,\"          \"],[8,[39,9],null,[[\"@buttonText\",\"@infoText\",\"@onClick\"],[[28,[37,3],[\"shared_words.refresh\"],null],[30,0,[\"autoPublishIssue\"]],[28,[37,10],[[30,0,[\"connectBusiness\"]],[30,2]],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"autoPublishIssue\"]],[[[1,\"          \"],[8,[39,11],null,[[\"@buttonAction\",\"@buttonText\",\"@infoText\",\"@showButton\"],[[30,0,[\"transitionToUpgrade\"]],[28,[37,3],[[52,[30,0,[\"showLegacyUpgrade\"]],\"posts.modal.auto_publish.switch_plan\",\"shared_words.upgrade\"]],null],[30,0,[\"autoPublishIssue\"]],[30,0,[\"showUpgrade\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isCreatorStory\"]],[[[1,\"          \"],[8,[39,9],null,[[\"@buttonText\",\"@infoText\",\"@onClick\",\"@title\"],[[28,[37,3],[\"posts.modal.auto_publish.setup_now\"],null],[30,0,[\"enableBusinessProfileText\"]],[30,0,[\"transitionToIgHelp\"]],[28,[37,3],[\"posts.modal.auto_publish.setup_publishing\"],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"canAutoPublish\"]],[[[1,\"          \"],[8,[39,8],null,[[\"@setPublishMethod\",\"@text\"],[[30,0,[\"setPublishMethod\"]],[28,[37,3],[\"posts.modal.auto_publish.auto_publish\"],null]]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,12],[[30,1,[\"isProfessional\"]],[30,1,[\"isTiktok\"]]],null],[[[1,\"            \"],[8,[39,9],null,[[\"@buttonText\",\"@infoText\",\"@onClick\"],[[28,[37,3],[[52,[30,1,[\"isTiktok\"]],\"shared_words.refresh\",\"posts.modal.auto_publish.connect_business\"]],null],[28,[37,3],[\"posts.modal.auto_publish.attach_profile\"],null],[28,[37,10],[[30,0,[\"connectBusiness\"]],[30,2]],null]]],null],[1,\"\\n\"]],[]],[[[1,\"            \"],[8,[39,9],null,[[\"@buttonText\",\"@infoText\",\"@onClick\",\"@title\"],[[28,[37,3],[\"posts.modal.auto_publish.setup_now\"],null],[30,0,[\"enableBusinessProfileText\"]],[28,[37,10],[[30,0,[\"openPublishingSetupPanel\"]],[30,2],[30,0,[\"autoPublishingSetupComponent\"]]],null],[30,0,[\"setupAutoPublishingText\"]]]],null],[1,\"\\n\"]],[]]],[1,\"        \"]],[]]]],[]]]],[]]]],[]]]],[]]],[1,\"      \"],[13],[1,\"\\n    \"]],[2]]]]],[1,\"\\n\"]],[]],null]],[]],null]],[\"@socialProfile\",\"emberDrop\",\"@post\"],false,[\"if\",\"concat-classes\",\"svg-jar\",\"t\",\"and\",\"not\",\"shared/ui/ember-drop\",\"concat\",\"shared/publish/switcher/item/publish-method\",\"shared/publish/switcher/item/business-button\",\"fn\",\"shared/publish/switcher/item/info-text\",\"or\"]]",
    "moduleName": "shared/components/shared/publish/switcher/index.hbs",
    "isStrictMode": false
  });
  let SwitcherComponent = _exports.default = (_dec = (0, _service.inject)('social/instagram-auth'), (_class = (_checkOnboardingAndOpen = /*#__PURE__*/new WeakSet(), _openPublishingSetupPanel = /*#__PURE__*/new WeakSet(), class SwitcherComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _openPublishingSetupPanel);
      _classPrivateMethodInitSpec(this, _checkOnboardingAndOpen);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "localStorageManager", _descriptor4, this);
      _initializerDefineProperty(this, "router", _descriptor5, this);
      _initializerDefineProperty(this, "secondaryModal", _descriptor6, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor7, this);
      _initializerDefineProperty(this, "tiktok", _descriptor8, this);
      _initializerDefineProperty(this, "instagramAuth", _descriptor9, this);
      _defineProperty(this, "invalidIgCarouselAutoPublishPlans", ['free']);
      _defineProperty(this, "elementId", (0, _uuid.default)());
      _defineProperty(this, "autoPublishSetupComponent", _constants.NO_PUBLISHING_METHOD_COMPONENTS.AUTO_PUBLISH_SETUP);
      _defineProperty(this, "notificationSetupComponent", _constants.NO_PUBLISHING_METHOD_COMPONENTS.NOTIFICATION_PUBLISH_SETUP);
      _defineProperty(this, "connectInstagramBusinessAccount", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (this.args.socialProfile.isInstagramLogin) {
            this.instagramAuth.refreshInstagramLogin.perform({
              socialProfile: this.args.socialProfile
            });
          } else {
            yield this.instagramAuth.authenticateWithFacebookGraphApi.perform({
              refreshSocialProfiles: [this.args.socialProfile]
            });
            if (this.args.socialProfile.needsRefresh) {
              this.instagramAuth.resetInstagramAuthStatusDates();
              this.args.showInstagramAuthStatus();
            }
          }
        }
      }), null, "connectInstagramBusinessAccount", null));
      _defineProperty(this, "refreshSocialProfileAndCheck", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.args.socialProfile.get('refreshAndReload').perform();
          _classPrivateMethodGet(this, _checkOnboardingAndOpen, _checkOnboardingAndOpen2).call(this);
        }
      }), null, "refreshSocialProfileAndCheck", null));
      this.refreshSocialProfileAndCheck.perform();
    }
    get isDisabled() {
      return !this.args.socialProfile.hasPublishingMethod || !this.args.post.isEditable || this.args.post.isDisabledDraft || this.args.isDisabledPost;
    }
    get shouldRenderEmberDrop() {
      return this.args.socialProfile.hasPublishingMethod && !this.args.post.isDisabledDraft && !this.args.isDisabledPost;
    }
    get showPublishSwitcher() {
      return this.args.socialProfile.isInstagram || this.args.socialProfile.isTiktok;
    }
    get autoPublishIssue() {
      if (this.args.socialProfile.isInstagram) {
        return this.instagramAutoPublishIssue;
      }
      if (this.args.socialProfile.isTiktok) {
        return this.tiktokAutoPublishIssue;
      }
      return '';
    }
    get instagramAutoPublishIssue() {
      if (this.args.isCarouselPost) {
        if (this.auth.currentAccount.canIgCarouselAutoPublish) {
          return '';
        }
        return this.showLegacyUpgrade ? this.intl.t('posts.modal.auto_publish.legacy_paid_upgrade') : this.intl.t('post.header.carousel_no_autopublish');
      }
      return '';
    }
    get tiktokAutoPublishIssue() {
      if (this.args.socialProfile.isTiktokUnverifiedAccount || this.args.socialProfile.isTiktokLoginKitAccount && !this.args.socialProfile.canConnectTiktokApi) {
        return this.intl.t('posts.modal.auto_publish.attach_profile');
      }
      return '';
    }
    get canAutoPublish() {
      return this.args.socialProfile.canAutoPublish && !this.isCreatorStory;
    }
    get contentClass() {
      return 'e--publishMethod--drop' + this.args.socialProfile.id;
    }
    get dropdownTargetClass() {
      return 'e--publishMethod--toggle' + this.args.socialProfile.id;
    }
    get isCreatorStory() {
      return this.args.post.isInstagramStory && this.args.socialProfile.isCreator;
    }
    get showLegacyUpgrade() {
      return this.auth.currentAccount.isOnLegacyPlan;
    }
    get showPlanUpgrade() {
      return this.invalidIgCarouselAutoPublishPlans.includes(this.subscriptions.subscriptionPlan.planType);
    }
    get showUpgrade() {
      return this.showPlanUpgrade || this.showLegacyUpgrade;
    }
    get shouldPromptConnectBusiness() {
      if (this.args.socialProfile.isInstagram) {
        return this.args.socialProfile.needsBusinessUpgradeToAutoPublish &&
        // prevents this from being "true" more than once -iMack
        !this.localStorageManager.getItem('seenDirectOnboarding2');
      }
      return this.args.socialProfile.needsBusinessUpgradeToAutoPublish;
    }
    get showAutoPublishButton() {
      if (this.args.socialProfile.isInstagram) {
        return this.args.socialProfile.canInstagramAutoPublish;
      }
      if (this.args.socialProfile.isTiktok) {
        return this.args.socialProfile.canTiktokAutoPublish;
      }
      return false;
    }
    get switcherText() {
      if (this.args.post.autoPublish) {
        return this.intl.t('posts.modal.auto_publish.auto_publish');
      } else if (this.args.post.isNotificationPost) {
        return this.intl.t('posts.modal.auto_publish.send_notification');
      }
      return this.intl.t('posts.modal.no_publishing_method.select_a_method');
    }
    get buttonText() {
      if (this.args.socialProfile.isInstagram) {
        return this.args.socialProfile.isProfessional ? this.intl.t('posts.modal.auto_publish.connect_business') : this.intl.t('posts.modal.auto_publish.setup');
      }
      if (this.args.socialProfile.isTiktok) {
        return this.intl.t('posts.modal.auto_publish.connect_business');
      }
      return '';
    }
    get infoText() {
      if (this.args.socialProfile.isProfessional) {
        return this.intl.t('posts.modal.auto_publish.attach_profile');
      }
      return this.args.socialProfile.isInstagram ? this.intl.t('posts.modal.auto_publish.go_enable_instagram') : this.intl.t('posts.modal.auto_publish.go_enable_tiktok');
    }
    get setupAutoPublishingText() {
      if (this.args.socialProfile.isProfessional) {
        return this.intl.t('posts.modal.notification_publish.setup_publishing');
      }
      return this.intl.t('posts.modal.auto_publish.setup_publishing');
    }
    get enableBusinessProfileText() {
      if (this.args.socialProfile.isInstagram) {
        return this.args.post.isInstagramStory ? this.intl.t('posts.modal.auto_publish.story_switch_to_business') : this.intl.t('posts.modal.auto_publish.switch_to_business');
      }
      return this.intl.t('posts.modal.auto_publish.go_enable_tiktok');
    }
    setPublishMethod() {
      (0, _object.set)(this.args.post, 'autoPublish', !this.args.post.autoPublish);
      if (this.args.post.isInstagramReel && !this.args.post.autoPublish && this.args.post.customCoverPMI) {
        this.args.removeCustomCover();
      }
    }
    openPublishingSetupPanel(emberDrop, componentName) {
      _classPrivateMethodGet(this, _openPublishingSetupPanel, _openPublishingSetupPanel2).call(this, componentName);
      emberDrop.closeAction();
    }
    transitionToUpgrade() {
      this.router.transitionTo('plans');
    }
    transitionToIgHelp() {
      if (!false) {
        window.open('https://help.later.com/hc/en-us/articles/360042770474');
      }
    }
    connectBusiness(emberDrop) {
      emberDrop.closeAction();
      if (this.args.socialProfile.isInstagram && this.args.socialProfile.isProfessional) {
        this.connectInstagramBusinessAccount.perform();
      } else {
        this.setupBusiness();
      }
    }
    async setupBusiness() {
      if (this.args.socialProfile.isTiktok) {
        const didConfirm = await this.dialogManager.confirmation(this.intl.t('shared_phrases.close_warning'), {
          description: this.intl.t('shared_phrases.changes_not_saved'),
          confirmButton: this.intl.t('shared_words.leave')
        });
        if (!didConfirm) {
          return;
        }
        return this.tiktok.loginWithBusinessApiAccount(this.args.socialProfile);
      }
      try {
        //last-minute to check if its professional, if so, update, else, forward to FB doc -iMack
        await this.args.socialProfile.get('refreshAndReload').perform();
        if (!this.args.socialProfile.isProfessional) {
          if (this.args.socialProfile.isInstagram) {
            this.transitionToIgHelp();
          }
          if (this.args.socialProfile.isTiktok) {
            //TODO: TikTok Bussiness API - Define KB link
            window.open('#', '_blank');
          }
        } else {
          if (this.args.socialProfile.isInstagram) {
            this.connectInstagramBusinessAccount.perform();
          }
          if (this.args.socialProfile.isTiktok) {
            this.connectTiktokBusinessAccount.perform();
          }
        }
      } catch (error) {
        this.router.transitionTo('account.groups.group.social_profiles', this.args.socialProfile.get('group.id'));
      }
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "localStorageManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "secondaryModal", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "tiktok", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "instagramAuth", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "setPublishMethod", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setPublishMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openPublishingSetupPanel", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openPublishingSetupPanel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "transitionToUpgrade", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "transitionToUpgrade"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "transitionToIgHelp", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "transitionToIgHelp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "connectBusiness", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "connectBusiness"), _class.prototype)), _class));
  function _checkOnboardingAndOpen2() {
    if (this.shouldPromptConnectBusiness) {
      this.localStorageManager.setItem('seenDirectOnboarding2', true);
    }
    if (!this.args.socialProfile.hasPublishingMethod) {
      _classPrivateMethodGet(this, _openPublishingSetupPanel, _openPublishingSetupPanel2).call(this);
    }
  }
  function _openPublishingSetupPanel2(componentName) {
    this.secondaryModal.toggleModal(this.elementId, _constants.SECONDARY_MODAL_TYPES.PUBLISHING_METHOD_SETUP, _constants.SECONDARY_MODAL_TARGETS.PUBLISHING_METHOD_SETUP);
    this.secondaryModal.setPublishingMethodSetupModalComponent(componentName);
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SwitcherComponent);
});